<div
    #button
    class="burger-menu"
    (click)="onClick()">
    <span
        #burgerBar
        class="burger-bar"></span>
</div>
